import LabelledElement from "./LabelledElement";
import { MenuItem, Select } from "@mui/material";
import { currencyFormat } from "common/numbers";

const PricingDefaultsElement = ({ label, options, data, onChange }) => {
  const makeKey = (obj) =>
    Object.entries(obj ?? {})
      .map(([k, v]) => `${k}_${v}`)
      .join("_");

  const makeLabel = (obj) =>
    Object.values(obj)
      .map((value) => currencyFormat(value))
      .join(" / ");

  const makeActiveKey = () => {
    const optionKeys = Object.keys(options?.[0]);
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([k]) => optionKeys.includes(k))
    );
    const key = makeKey(filteredData);
    return options.map((x) => makeKey(x)).includes(key) ? key : "";
  };

  const value = makeActiveKey();

  const handleChange = (value) => {
    const obj = options.find((x) => makeKey(x) === value);
    onChange(obj);
  };

  return (
    <LabelledElement label={label}>
      <Select
        size={"small"}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={makeKey(option)}>
            {makeLabel(option)}
          </MenuItem>
        ))}
      </Select>
    </LabelledElement>
  );
};

export default PricingDefaultsElement;
